import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import { TaskDescriptionTip } from '../components/TaskDescriptionTip.tsx';
import TaskCompleteButton from '../components/TaskCompleteButton.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import { messages } from './prioritizeAndPlan.messages.tsx';
import { TASK_PRIORITIZE_AND_PLAN } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	return (
		<TaskDescription>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionTip>{formatMessage(messages.tip)}</TaskDescriptionTip>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			<TaskCompleteButton taskId={TASK_PRIORITIZE_AND_PLAN} />
		</TaskDescription>
	);
};

export const prioritizeAndPlan = {
	id: TASK_PRIORITIZE_AND_PLAN,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
